var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sino-wealth"},[_c('el-header',{staticClass:"sw-header",staticStyle:{"padding":"0"}},[_c('sw-header')],1),_vm._v(" "),_c('el-main',{staticClass:"sw-main"},[_c('router-view')],1),_vm._v(" "),_c('el-footer',{staticClass:"sw-footer"},[_c('sw-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9ec8e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = null
// module chunks = 